<div class="profile-flex-container">
  <div class="profile-flex">
    <app-profile-sidebar activePage="group-tickets-profile" class="z-2 profile-sidebar m-w-100" ></app-profile-sidebar>

    <ng-container *ngIf="seasonTicketsDisplay && seasonTicketsDisplay.length === 0 && areGroupTicketsLoaded">

      <div class="events-list-group-tickets" *ngIf="areGroupTicketsLoaded && allEvents && allEvents.length > 0">
        <app-events-list
          [allEvents]="allEvents"
          [isUserProfilePage]="true"
          *ngIf="allEvents"
          >
        </app-events-list>
      </div>
    </ng-container>

    <ng-container *ngIf="seasonTicketsDisplay && seasonTicketsDisplay.length > 0 && seasonTicketsDisplay[0] !== null">
      <p class="profile-title">{{ "PROFILE.YOUR_GROUP_TICKETS" | translate }}</p>
      <div class="group-tickets-container">
        <div class="season-card-container" *ngFor="let seasonTicket of seasonTicketsDisplay">
          <div class="season-card-new">
            <ng-container *ngTemplateOutlet="groupTicketsDetails; context: { $implicit: seasonTicket }"></ng-container>

            <div class="buttons-container">
              <button class="btn btn-default" (click)="getTransactionInPdf(seasonTicket.transId, 'invoice')" *ngIf="seasonTicket.hasInvoice">{{ "PROFILE.DOWNLOAD_INVOICE_BUTTON" | translate }}</button>
              <button class="btn btn-secondary" (click)="openGroupTicketModal(seasonTicket)" *ngIf="seasonTicket.groupTicket && seasonTicket.barcode !== null">
                {{ "TICKETS.BARCODE" | translate }}
              </button>
              <button class="btn btn-primary" (click)="getTransactionInPdf(seasonTicket.transId, 'tickets')" *ngIf="!seasonTicket.groupTicket">{{ "PROFILE.DOWNLOAD_TICKETS" | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="connect-group-tickets-container" *ngIf="areGroupTicketsLoaded">
      <div class="connect-group-tickets-content">
        <p class="profile-subtitle">{{ "PROFILE.GROUP_TICKETS_CONNECT" | translate }}</p>
        <p class="profile-description">{{ "PROFILE.GROUP_TICKETS_CONNECT_INFO" | translate }}</p>

        <form [formGroup]="connectSeasonTicketForm" class="form user-form">
          <div class="user-form-input" [class.invalid]="connectSeasonTicketForm.get('barcode')?.invalid && connectSeasonTicketForm.get('barcode')?.touched">
            <label class="user-form-input-label" for="barcode">{{ "PROFILE.GROUP_TICKETS_CONNECT_BARCODE" | translate }} *</label>
            <input type="number" name="barcode" formControlName="barcode" class="form-control" placeholder=" " data-name="connect-new-membership-input" (input)="limitInputLengthForNumberic($event)" />
          </div>

          <div class="user-form-input" [class.invalid]="connectSeasonTicketForm.get('dat_rodj')?.invalid && connectSeasonTicketForm.get('dat_rodj')?.touched">
            <label class="user-form-input-label" for="dat_rodj">{{ "INPUTS.DATEBIRTH" | translate }} *</label>
            <input id="dat_rodj" [dropSpecialCharacters]="false" mask="00.00.0000" type="text" name="dat_rodj" formControlName="dat_rodj" class="form-control" placeholder=" " data-name="connect-new-membership-input" />
          </div>

          <button class="btn btn-primary" (click)="onSubmitConnectSeasonTicket()">{{ "PROFILE.GROUP_TICKETS_CONNECT_2" | translate }}</button>
        </form>

        <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
        <p class="success-message" *ngIf="infoMessage">{{ infoMessage }}</p>
      </div>

      <!--<div class="season-ticket-connect-img-container">
        <img class="season-ticket-connect-img" alt="" />
      </div>-->
    </div>
  </div>
</div>

<section id="membership-card-modal-container" *ngIf="isMembershipCardModalOpen()">
  <div class="modal modal-container" (mousedown)="modalService.closeModal(modalNamesEnum.MembershipCard)">
    <div class="modal-content" (mousedown)="$event.stopPropagation()">
      <button type="button" class="btn-close" (click)="modalService.closeModal(modalNamesEnum.MembershipCard)" [attr.title]="'COMMON.CLOSE' | translate">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 17 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.79287 8.6478L1 1.85493L1.70711 1.14783L8.49997 7.94069L15.2928 1.14783L15.9999 1.85493L9.20708 8.6478L15.4982 14.9389L14.7911 15.646L8.49997 9.35491L2.20887 15.646L1.50176 14.9389L7.79287 8.6478Z" fill="#797979"/>
          <path d="M1 1.85493L0.823223 1.67816C0.776339 1.72504 0.75 1.78863 0.75 1.85493C0.75 1.92124 0.776339 1.98483 0.823223 2.03171L1 1.85493ZM7.79287 8.6478L7.96964 8.82458C8.01653 8.77769 8.04287 8.7141 8.04287 8.6478C8.04287 8.5815 8.01653 8.51791 7.96964 8.47102L7.79287 8.6478ZM1.70711 1.14783L1.88388 0.97105C1.78625 0.873419 1.62796 0.873419 1.53033 0.97105L1.70711 1.14783ZM8.49997 7.94069L8.3232 8.11747C8.42083 8.2151 8.57912 8.2151 8.67675 8.11747L8.49997 7.94069ZM15.2928 1.14783L15.4696 0.97105C15.372 0.873419 15.2137 0.873419 15.1161 0.97105L15.2928 1.14783ZM15.9999 1.85493L16.1767 2.03171C16.2236 1.98483 16.2499 1.92124 16.2499 1.85493C16.2499 1.78863 16.2236 1.72504 16.1767 1.67816L15.9999 1.85493ZM9.20708 8.6478L9.0303 8.47102C8.93267 8.56865 8.93267 8.72694 9.0303 8.82458L9.20708 8.6478ZM15.4982 14.9389L15.675 15.1157C15.7726 15.0181 15.7726 14.8598 15.675 14.7621L15.4982 14.9389ZM14.7911 15.646L14.6143 15.8228C14.7119 15.9204 14.8702 15.9204 14.9679 15.8228L14.7911 15.646ZM8.49997 9.35491L8.67675 9.17813C8.57912 9.0805 8.42083 9.0805 8.3232 9.17813L8.49997 9.35491ZM2.20887 15.646L2.03209 15.8228C2.12972 15.9204 2.28801 15.9204 2.38564 15.8228L2.20887 15.646ZM1.50176 14.9389L1.32498 14.7621C1.2781 14.809 1.25176 14.8726 1.25176 14.9389C1.25176 15.0052 1.2781 15.0688 1.32498 15.1157L1.50176 14.9389ZM0.823223 2.03171L7.61609 8.82458L7.96964 8.47102L1.17678 1.67816L0.823223 2.03171ZM1.53033 0.97105L0.823223 1.67816L1.17678 2.03171L1.88388 1.3246L1.53033 0.97105ZM8.67675 7.76392L1.88388 0.97105L1.53033 1.3246L8.3232 8.11747L8.67675 7.76392ZM8.67675 8.11747L15.4696 1.3246L15.1161 0.97105L8.3232 7.76392L8.67675 8.11747ZM15.1161 1.3246L15.8232 2.03171L16.1767 1.67816L15.4696 0.97105L15.1161 1.3246ZM15.8232 1.67816L9.0303 8.47102L9.38386 8.82458L16.1767 2.03171L15.8232 1.67816ZM15.675 14.7621L9.38386 8.47102L9.0303 8.82458L15.3214 15.1157L15.675 14.7621ZM14.9679 15.8228L15.675 15.1157L15.3214 14.7621L14.6143 15.4692L14.9679 15.8228ZM8.3232 9.53168L14.6143 15.8228L14.9679 15.4692L8.67675 9.17813L8.3232 9.53168ZM8.3232 9.17813L2.03209 15.4692L2.38564 15.8228L8.67675 9.53168L8.3232 9.17813ZM2.38564 15.4692L1.67853 14.7621L1.32498 15.1157L2.03209 15.8228L2.38564 15.4692ZM1.67853 15.1157L7.96964 8.82458L7.61609 8.47102L1.32498 14.7621L1.67853 15.1157Z" fill="#797979"/>
        </svg>
      </button>

      <div>
        <ng-container *ngTemplateOutlet="groupTicketsDetails; context: { $implicit: selectedGroupTicket }"></ng-container>

        <ngx-barcode6
          class="ngx-barcode"
          [bc-format]="'CODE128'"
          [bc-value]="selectedGroupTicket.barcode"
          [bc-display-value]="true"
          [bc-width]="2.2"
          [bc-font-size]="15"
          [bc-height]="40"
          [bc-text-margin]="5"
          [bc-font]="'Sofia Sans'"
        >
        </ngx-barcode6>
      </div>
    </div>
  </div>
</section>

<ng-template #groupTicketsDetails let-seasonTicket>
  <span class="season-card-name bold">{{ seasonTicket.ticketOwnerName }}</span>
  <p class="season-card-barcode"><span class="bold">{{ "TICKETS.BARCODE" | translate }}:</span> {{ seasonTicket.barcode }}</p>
  <p class="season-card-season" *ngIf="seasonTicket.seasons"><span class="bold">{{ "TICKETS.SEASON" | translate }}: </span> {{ seasonTicket.seasons }}</p>
  <span class="card-group-name">{{ seasonTicket.groupName }}</span>

  <div class="season-card-info-container">
    <p><span class="bold">{{ "TICKETS.SECTOR" | translate }}:</span>&nbsp;{{ seasonTicket.sectorName }},&nbsp;</p>
    <p><span class="bold">{{ "TICKETS.ROW" | translate }}:</span>&nbsp;{{ seasonTicket.row }},&nbsp;</p>
    <p><span class="bold">{{ "TICKETS.SEAT" | translate }}:</span>&nbsp;{{ seasonTicket.seat }}</p>
  </div>
</ng-template>

<app-notification *ngIf="showNotification" [bodyText]="bodyText | translate"></app-notification>
